import { FullBooking } from '@alluradirect/react';
import { Typography } from '@mui/material';
import { AppDivider } from 'components/core/AppDivider/AppDivider';
import ConfirmationDialog from 'components/core/ConfirmationDialog/ConfirmationDialog';
import Grid from 'components/core/Grid';
import { LabelAndValue } from 'components/core/LabelAndValue/LabelAndValue';
import {
  taxTotal,
  taxTotalsBreakdown,
  nightsTotal,
} from 'components/views/pages/Checkout/CheckoutSummary/helpers';
import { BookingCheckoutResponse } from 'components/views/pages/Checkout/hooks/useCheckout';
import { formatCanadianCurrency } from 'helpers/currencyHelpers';

interface Props {
  isOpen: boolean;
  close: () => void;
  checkoutData: BookingCheckoutResponse | undefined;
  bookingData: FullBooking | undefined;
  isLastStep: boolean;
  currency_code: string;
  currency_multiplier: number;
}

export const CheckoutSummaryOccupancyTaxDialog = ({ isOpen, close, checkoutData, bookingData, isLastStep, currency_code, currency_multiplier }: Props) => {
  const taxTotals = taxTotalsBreakdown({ checkoutData, bookingData, isLastStep });
  const occupancyTaxTotal = taxTotal({ checkoutData, bookingData, isLastStep });
  const totalNights = nightsTotal({ checkoutData, bookingData, isLastStep });

  return (
    <ConfirmationDialog
      isDialogOpen={isOpen}
      handleCloseDialog={close}
      hasBottomBar={false}
      dialogTitle="Taxes"
      useIsXs={false}
      maxWidth="xs"
    >
      <Grid container spacing={1}>

        {totalNights > 29 ?

          <Grid item xs={12}>
            <Typography variant="body2">
              {totalNights > 29 ? (
                'Tax is exempt on long-term stays of 30 nights or greater'
              ) : (
                ''
              )}
            </Typography>

            <AppDivider />
          </Grid>

          : null}

        {taxTotals.map(taxTotal => {
          const label = `${taxTotal.NAME} (${taxTotal.RATE}%)`;
          const value = formatCanadianCurrency(taxTotal.AMOUNT, { currency_code, currency_multiplier });

          return (
            <Grid item xs={12} key={taxTotal.ID}>
              <LabelAndValue label={label} value={value} variant="accounting" fontWeight="500" />
            </Grid>
          );
        })}

        {totalNights < 29 ?
          <Grid item xs={12}>
            <AppDivider />
          </Grid>
          : null}

        <Grid item xs={12}>
          <LabelAndValue
            label={'Total'}
            value={`${formatCanadianCurrency(occupancyTaxTotal, { minMaxFractionDigits: 2, currency_code, currency_multiplier })}`}
            variant="accounting"
            fontWeight="500"
          />
        </Grid>
      </Grid>
    </ConfirmationDialog>
  );
};
